import { render, staticRenderFns } from "./TagPageSocial.vue?vue&type=template&id=2673a8fa&scoped=true"
import script from "./TagPageSocial.vue?vue&type=script&lang=ts"
export * from "./TagPageSocial.vue?vue&type=script&lang=ts"
import style0 from "./TagPageSocial.vue?vue&type=style&index=0&id=2673a8fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2673a8fa",
  null
  
)

export default component.exports